import React, { Fragment, useState } from "react";
import I18n from "i18n-js";

import ActionButton from "../../commons/ActionButton";

import NewTrainingCourseModal from "../modals/NewTrainingCourseModal";

import plusIcon from "../../assets/icons/plus.svg";

const NewTrainingCourseButton = () => {

  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);

  return (
    <Fragment>
      <ActionButton
        title={I18n.t("training_courses.actions.new")}
        icon={plusIcon}
        onClick={() => toggleModal()}
      />
      {showModal ? <NewTrainingCourseModal onClose={() => toggleModal()} /> : null}
    </Fragment>
  );
}

export default NewTrainingCourseButton;
